import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import React from 'react'

export interface SvgIconProps {
  /**
   * The color of the icon
   * @default 'inherit'
   */
  color?: SvgIconColor
  /**
   * The viewBox attribute for the SVG element
   * @default '0 0 24 24'
   */
  viewBox?: string
}

export type SvgIconColor = 'default' | 'inherit' | 'primary' | 'secondary'

type SvgIconColors = {
  [key in SvgIconColor]: string
}

const colors: SvgIconColors = {
  default: 'text-black-60',
  inherit: 'text-inherit',
  primary: 'text-primary-main',
  secondary: 'text-secondary-main',
}

function SvgIcon({
  children,
  color = 'inherit',
  viewBox,
}: PropsWithChildren<SvgIconProps>): JSX.Element {
  return (
    <svg
      aria-hidden="true"
      className={clsx('select-none w-full h-auto', colors[color])}
      fill="currentColor"
      focusable="false"
      viewBox={viewBox || '0 0 24 24'}
      width="0"
    >
      {children}
    </svg>
  )
}

export default SvgIcon
